import { createI18n } from 'vue-i18n'
import zhCN from './locales/zh-CN'
import en from './locales/en'

export type AppLocale = 'zh-CN' | 'en'

const STORAGE_KEY = 'airops.locale'

function getInitialLocale(): AppLocale {
  const saved = localStorage.getItem(STORAGE_KEY)
  if (saved === 'zh-CN' || saved === 'en') return saved
  return 'zh-CN'
}

const i18n = createI18n({
  legacy: false,
  locale: getInitialLocale(),
  fallbackLocale: 'zh-CN',
  messages: {
    'zh-CN': zhCN,
    en,
  },
  missingWarn: false,
  fallbackWarn: false,
})

export function setDocumentLocale(locale: AppLocale): void {
  document.querySelector('html')?.setAttribute('lang', locale)
  localStorage.setItem(STORAGE_KEY, locale)
}

setDocumentLocale(getInitialLocale())

export default i18n
